export default function makeDetailFlagsConvert({ base }) {
	const { advertisement, condition, contact, vehicleType, manage, partnership, view } = base;

	const isDealer = contact?.userType === 'DEALER';
	const isTruck = vehicleType === 'TRUCK';
	const encarService = advertisement?.trust;
	const isMeetgo = encarService?.includes('Meetgo'); // 믿고 여부
	const isHomeService = encarService?.includes('HomeService'); // 홈서비스 여부
	const isDiagnosisExist = encarService?.includes('Warranty'); // 엔카 진단(무사고) 여부
	const isExtendWarranty = encarService?.includes('ExtendWarranty'); // 엔카 보증 여부
	const isCompensate = encarService?.includes('Compensate'); // 헛걸음 보상여부
	const isCarVerification = advertisement?.verification?.reportExists; // 차량 리포트 여부
	const isDirectManagement = advertisement?.directInspected; // 엔카직영성능 여부
	const isEncarService = isMeetgo || isHomeService;
	const isEncarCheck = advertisement?.encarCheck === true;
	const isInnerPanorama = advertisement?.innerPanorama.available === true; // 실내 360 제공 여부
	const isInsuranceExist = condition?.accident?.recordView; // 보험 이력 공개 여부
	const isHistoryView = condition?.accident?.resumeView; // 차량 이력 공개 여부(관리자 처리)
	const isBrandCertification = partnership?.brand;
	const isDummySafetyZone = partnership?.dealer?.firm?.diag2Partnered && isMeetgo && manage?.dummy;
	const isSafetyZoneExpert = !!view?.meetgoExpertAvailable; // 믿고 전문가 동행 가능 여부
	const isMeetgoCheckupAvailable = !!view?.meetgoCheckupAvailable; // 전문가 출장 검수 제공 여부
	const isMeetgoVisitAvailable = !!view?.meetgoVisitAvailable; // 믿고 거래존 방문 제공 여부 (양산점 - 일반 믿고 방문은 불가능, 전문가 동행 + 믿고 거래존은 가능)
	const isBrandCertificationDomestic = partnership?.certifiedBrand !== null;
	const isAffiliateRent = partnership?.rent !== null;
	const isAffiliateLease = partnership?.lease !== null;
	const affiliateCompanyId = partnership?.certifiedBrand?.companyId || partnership?.rent?.companyId || partnership?.lease?.companyId;
	const isBatteryPass = view?.isBatteryPass; // EV 배터리 진단 PASS(성능) 여부
	const hasEvBatteryInfo = view?.hasEvBatteryInfo; // EV 배터리 진단 정보 보유 여부
	const isBatteryCompensable = view?.isBatteryCompensable; // 배터리 보상 패키지 배너 노출 여부

	// 광고 타입 AD_DUMMY => 전용 광고, AD_NORMAL => 일반 광고 (노멀 수정)
	const advertisementType = (() => {
		if (isEncarService && manage?.dummy) return 'AD_DUMMY';
		return 'AD_NORMAL';
	})();

	// 더미 존재하는 일반 광고
	const isAvailableMoveToDummy = (() => {
		if (isEncarService && !manage?.dummy) return true;
		return false;
	})();

	// 성능 점검 타입 INSPECT => 성능 점검, INSPECT_IMG => 이미지로 등록, ENCAR_INSPECT => 엔카 직영 성능
	const inspectType = (() => {
		const inspection = condition?.inspection.formats;
		const isInspection = inspection?.length > 0;
		const isInspectImg = !inspection?.includes('TABLE') && inspection?.includes('IMAGE');

		if (isDirectManagement) return 'ENCAR_INSPECT';
		if (isInspection) {
			if (isInspectImg) return 'INSPECT_IMG';
			return 'INSPECT';
		}

		return null;
	})();

	// 리스∙렌트 타입 NO_TYPE => 해당 없음, LEASE => 리스, RENT_SUCCESSION => 렌트 승계, RENT => 렌트
	const leaseRentType = (() => {
		const type = advertisement?.advertisementType;

		if (type?.includes('LEASE')) return 'LEASE'; // OPERATING_LEASE | FINANCING_LEASE
		if (type === 'RENT_SUCCESSION') return 'RENT_SUCCESSION';
		if (type === 'RENT_CAR') return 'RENT';

		return 'NO_TYPE';
	})();

	// 엔카진단 태그 타입 null => 해당 없음, DIAGNOSIS => 엔카진단, DIAGNOSIS_P => 엔카진단+, DIAGNOSIS_PP => 엔카진단++ (일반/전용에 따라 기준 달라짐)
	const encarDiagnosisTag = (() => {
		if (!isDiagnosisExist) return null; // 엔카진단 해당 X
		const standard = view?.encarDiagnosis;

		if (standard === 0) return 'DIAGNOSIS'; // 엔카진단
		if (standard === 1) return 'DIAGNOSIS_P'; // 엔카진단+
		if (standard === 2) return 'DIAGNOSIS_PP'; // 엔카진단++

		return null;
	})();

	// 광고 상태
	const adStatus = (() => {
		const status = base.advertisement?.status;

		if (status === 'ADVERTISE') return 'advertise';
		if (status === 'SOLD') return 'soldOut';
		if (status === 'WAIT') return 'wait';
		return null;
	})();

	const encarServiceType = (() => {
		const isDiag2Partner = partnership?.dealer?.firm?.diag2Partnered;
		if (isDiag2Partner && isMeetgo) return 'diagnosis2'; // 믿고 & 진단2.0제휴
		if (isMeetgo) return 'meetgoEssential'; // 기존 믿고 제휴
		if (isHomeService) return 'onlyHomeservice'; // 홈서비스만 제휴
		return null;
	})();

	return {
		isAvailableMoveToDummy, // 더미 존재하는 딜러 광고
		isBrandCertification, // 브랜드 인증 차량
		isBrandCertificationDomestic, // 국산 브랜드 인증 차량
		isAffiliateRent, // 렌트제휴
		isAffiliateLease, // 리스제휴
		affiliateCompanyId, // 제휴사 코드
		isCarVerification, // 차량 리포트 여부
		isCompensate, // 헛걸음 보상 여부
		isDealer, // 매매회원 여부
		isDiagnosisExist, // 엔카진단(무사고) 여부
		isExtendWarranty, // 보증 여부
		isHomeService, // 홈서비스 여부
		isInsuranceExist, // 보험 이력 공개 여부
		isHistoryView, // 차량 이력 공개 여부
		isMeetgo, // 믿고 여부
		isDummySafetyZone, // 진단2.0 안전거래존(전용광고)
		isSafetyZoneExpert, // 믿고 전문가 동행 가능 여부
		isMeetgoCheckupAvailable, // 전문가 출장 검수 제공 여부
		isMeetgoVisitAvailable, // 믿고 거래존 방문 제공 여부
		isTruck,
		adStatus, // 광고 상태
		advertisementType, // 광고 타입: AD_DUMMY(전용 광고), AD_NORMAL(일반 광고)
		encarDiagnosisTag, // 엔카진단 태그 타입: null(해당 없음), DIAGNOSIS(엔카진단), DIAGNOSIS_P(엔카진단+), DIAGNOSIS_PP(엔카진단++)
		inspectType, // 성능 점검 타입: INSPECT(성능 점검), INSPECT_IMG(이미지로 등록), ENCAR_INSPECT(엔카 직영 성능)
		leaseRentType, // 리스∙렌트 타입: NO_TYPE(해당 없음), LEASE(리스), RENT_SUCCESSION(렌트 승계), RENT(장기렌트)
		encarServiceType, // 믿고&진단2.0제휴, 믿고에센셜제휴, 홈서비스제휴
		isEncarCheck,
		isInnerPanorama, // 실내 360 제공 여부
		isBatteryPass, // EV 배터리 진단 PASS(성능) 여부
		hasEvBatteryInfo, // EV 배터리 진단 정보 보유 여부
		isBatteryCompensable, // 배터리 보상 패키지 배너 노출 여부
	};
}
